export const VESIS_SEO_DATA: Record<string, { title: string; description: string; apr: string }> = {
	mainnet: {
		title: 'Lock your on Ethereum SIS and earn 18% APR + veSIS governance rewards | Symbiosis',
		description: 'Lock SIS tokens on Ethereum to earn 18% APR in SIS and receive veSIS for participation in Symbiosis DAO and exclusive ecosystem rewards.',
		apr: '18%',
	},
	bnb: {
		title: 'Lock your SIS on BNB Chain and earn 28% APR + veSIS governance rewards | Symbiosis',
		description: 'Lock SIS tokens on BNB Chain to earn 28% APR in SIS and receive veSIS for participation in Symbiosis DAO and exclusive ecosystem rewards.',
		apr: '28%',
	},
	zksync: {
		title: 'Lock your on zkSync SIS and earn 16.61% APR + veSIS governance rewards | Symbiosis',
		description: 'Lock SIS tokens on zkSync to earn 16.61% APR in SIS and receive veSIS for participation in Symbiosis DAO and exclusive ecosystem rewards.',
		apr: '16.61%',
	},
	linea: {
		title: 'Lock your on Linea SIS and earn 20.36% APR + veSIS governance rewards | Symbiosis',
		description: 'Lock SIS tokens on Linea to earn 20.36% APR in SIS and receive veSIS for participation in Symbiosis DAO and exclusive ecosystem rewards.',
		apr: '20.36%',
	},
}